import { useHistory, useParams } from "react-router-dom";

import { useEffect } from "react";

const AssistantPersonaRedirect = () => {
  const history = useHistory();
  const { slug_name: slugName } = useParams<{ slug_name: string }>();

  useEffect(() => {
    if (slugName) {
      history.replace(`/assistant?persona=${slugName}`);
    }
  }, [slugName, history]);
};

export default AssistantPersonaRedirect;
